import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp, stagger } from '@/lib/motion';
import { Section, SectionTitle } from '@/components/shared/Section';

// Default gallery images per context
const defaultGalleries = {
  'autoservicio': [
    { url: 'https://images.unsplash.com/photo-1764795849878-59b546cfe9c7?w=400&q=75', caption: 'Implementaci\u00f3n de kioscos self-checkout' },
    { url: 'https://images.unsplash.com/photo-1764795850248-97a5e986b242?w=400&q=75', caption: 'Tienda con tecnolog\u00eda ALLCOM' },
    { url: 'https://images.unsplash.com/photo-1590404816012-f7fefd6fd443?w=400&q=75', caption: 'Punto de autoservicio en operaci\u00f3n' },
    { url: 'https://images.unsplash.com/photo-1682579306786-8afc3df52dd2?w=400&q=75', caption: 'Despliegue de equipos en sala' },
  ],
  'esl': [
    { url: 'https://images.unsplash.com/photo-1601599963565-b7ba29c8ff?w=400&q=75', caption: 'Etiquetas electr\u00f3nicas en g\u00f3ndola' },
    { url: 'https://images.unsplash.com/photo-1601599964574-cddabfa36549?w=400&q=75', caption: 'Sistema ESL en supermercado' },
    { url: 'https://images.unsplash.com/photo-1601600576337-c1d8a0d1373c?w=400&q=75', caption: 'Precios digitales actualizados' },
    { url: 'https://images.unsplash.com/photo-1764795849833-6e9d6e399a77?w=400&q=75', caption: 'Operaci\u00f3n con ESL SOLUM' },
  ],
  'default': [
    { url: 'https://images.unsplash.com/photo-1764795849878-59b546cfe9c7?w=400&q=75', caption: 'Proyecto de implementaci\u00f3n' },
    { url: 'https://images.unsplash.com/photo-1573878220075-17bb8dad878d?w=400&q=75', caption: 'Equipo t\u00e9cnico en terreno' },
    { url: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&q=75', caption: 'Dashboard de monitoreo' },
    { url: 'https://images.unsplash.com/photo-1769240628173-155c849658cc?w=400&q=75', caption: 'Operaci\u00f3n en faena' },
  ],
};

const ProjectGallery = ({ context = 'default', title = 'Proyectos realizados' }) => {
  const images = defaultGalleries[context] || defaultGalleries['default'];
  
  return (
    <Section alt>
      <SectionTitle badge="GALERIA" title={title} subtitle="Confianza respaldada por proyectos reales implementados en Chile." center />
      <motion.div variants={stagger} className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {images.map((img, i) => (
          <motion.div key={i} variants={fadeUp} className="group relative rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow aspect-[4/3]">
            <img src={img.url} alt={img.caption} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity">
              <p className="text-xs text-white font-medium">{img.caption}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </Section>
  );
};

export default ProjectGallery;
